import DatePicker from './DatePicker'
import { DATE_FORMAT } from 'shared/constants'
import classNames from 'classnames'

export const DateRange = ({
    className = '',
    onChange = () => {},
    minimumDifferenceInDays = 0,
    startOfWeek = 1,
    clear = false,
    start,
    end,
    startOptions,
    endOptions,
    clearOptions,
}) => {
    const [startDate, setStartDate] = React.useState(start)
    const [endDate, setEndDate] = React.useState(end)
    const [isEndFocused, setIsEndFocused] = React.useState(false)
    const [isStartFocused, setIsStartFocused] = React.useState(false)

    const onFocusChange = focused => {
        setIsStartFocused(focused)
    }

    const onStartChange = start => {
        setStartDate(start)
        setIsStartFocused(false)
        setIsEndFocused(true)
        let recalculatedEnd = endDate

        if (start.clone().add(minimumDifferenceInDays, 'd').isSameOrAfter(endDate)) {
            recalculatedEnd = start.clone().add(minimumDifferenceInDays, 'd')
            setEndDate(recalculatedEnd)
        }

        onChange(start, recalculatedEnd)
    }

    const onEndChange = end => {
        setEndDate(end)
        setIsEndFocused(false)
        let recalculatedStart = startDate

        if (end.clone().subtract(minimumDifferenceInDays, 'm').isSameOrBefore(startDate)) {
            recalculatedStart = end.clone().subtract(minimumDifferenceInDays, 'd')
            setStartDate(recalculatedStart)
        }

        onChange(recalculatedStart, end)
    }

    const onClearHandler = () => {
        setStartDate(start)
        setEndDate(end)
        onChange(start, end)
    }

    const isFilterApplied = React.useMemo(
        () => startDate !== start || endDate !== end,
        [startDate, endDate, start, end]
    )

    return (
        <div
            className={classNames('date-time-range', 'row no-gutters', {
                [className]: className,
            })}>
            <div
                className={classNames('d-flex align-self-md-end', {
                    col: !clear,
                    'col-11': clear,
                })}>
                <div className="w-100">
                    <DatePicker
                        focused={isStartFocused}
                        onFocusChange={onFocusChange}
                        value={startDate}
                        onChange={onStartChange}
                        displayFormat={DATE_FORMAT}
                        startOfWeek={startOfWeek}
                        {...startOptions}
                    />
                </div>
                <div className="w-100">
                    <DatePicker
                        focused={isEndFocused}
                        onFocusChange={onFocusChange}
                        value={endDate}
                        onChange={onEndChange}
                        displayFormat={DATE_FORMAT}
                        startOfWeek={startOfWeek}
                        {...endOptions}
                    />
                </div>
            </div>
            {clear && (
                <div className="col-1 align-self-center">
                    {isFilterApplied && (
                        <button className="text-center mt-3 text-small date-time-range__clear" onClick={onClearHandler}>
                            {clearOptions && clearOptions.label ? clearOptions.label : <T>date-picker.clear.label</T>}
                        </button>
                    )}
                </div>
            )}
        </div>
    )
}

DateRange.propTypes = {
    // moment object
    start: PropTypes.shape({}),
    minimumDifferenceInDays: PropTypes.number.isRequired,
    startOfWeek: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    startOptions: PropTypes.shape({}),
    endOptions: PropTypes.shape({}),
    clear: PropTypes.bool,
}

export default DateRange
